export enum TranslationOwnership {
    Public = 1,
    Shared = 2,
    Local = 3,
    Customer = 4,
    Private = 5,
    Own = 6
}